import React from 'react';

import classNames from 'classnames';
import CheckIcon from 'icons/check.svg';
import PropTypes from 'prop-types';

const sizes = {
  md: { box: 'tw-h-5.5 tw-w-5.5', icon: 'tw-h-2.5 tw-w-3.5' },
  sm: { box: 'tw-h-4 tw-w-4', icon: 'tw-h-2 tw-min-w-[10px]' },
};

export default function Checkbox({
  checkedIcon: CheckedIcon = CheckIcon,
  isChecked,
  isDisabled = false,
  label,
  name,
  onChange,
  size = 'sm',
}) {
  return (
    <label
      className={classNames(
        'tw-m-0 tw-flex tw-items-center',
        !isDisabled && 'tw-cursor-pointer',
      )}
    >
      <input
        aria-label={label}
        checked={isChecked}
        className='tw-peer/input tw-sr-only'
        disabled={isDisabled}
        name={name}
        onChange={onChange}
        type='checkbox'
      />
      <span
        className={classNames(
          'tw-flex tw-items-center tw-justify-center tw-rounded-sm tw-border-2 tw-border-solid',
          sizes[size].box,
          isChecked ?
            'tw-border-blue-400 tw-bg-blue-400'
          : 'tw-border-grey-300 tw-bg-white',
          {
            'tw-opacity-30': isDisabled,
            'hover:tw-border-blue-300': !isChecked && !isDisabled,
          },
        )}
      >
        {isChecked && <CheckedIcon className={sizes[size].icon} />}
      </span>
    </label>
  );
}

Checkbox.propTypes = {
  checkedIcon: PropTypes.elementType,
  isChecked: PropTypes.bool.isRequired,
  isDisabled: PropTypes.bool,
  label: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  size: PropTypes.oneOf(Object.keys(sizes)),
};
